
import { Component, OnInit, Input, OnDestroy, inject } from '@angular/core';
import { Food } from 'src/interfaces/food.model';
import { Labels } from 'src/interfaces/enums.model';
import { DataService } from 'src/app/services/data.service';
import { BasketService } from 'src/app/services/basket.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuFoodDialogComponent } from '../menu-food-dialog/menu-food-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { ScrollService } from 'src/app/services/scroll.service';

import { cloneDeep } from 'lodash-es';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LocalizationService } from 'src/app/services/localization.service';
import { Locale } from 'src/interfaces/locale.model';
import { FieldTranslatePipe } from 'src/app/pipes/field-translate.pipe';

@Component({
    selector: 'app-food-card',
    templateUrl: './menu-food-card.component.html',
    styleUrls: ['./menu-food-card.component.css'],
    standalone: false
})

export class FoodCardComponent implements OnInit, OnDestroy {
  constructor(private dataService: DataService,
    private basketService: BasketService,
    private scrollService: ScrollService,
    private fieldTranslate: FieldTranslatePipe,
    private dialog: MatDialog
  ) {
    this.locale = this.dataService.locale;
  }
  locale: Locale | null = null;

  title: string = '';
  basketFood: Food | null = null;

  @Input() food: Food | null = null;
  @Input() stoplist: boolean = false;
  @Input() isLast: boolean = false;

  Labels = Labels;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.food) {
      this.title = this.fieldTranslate.transform(this.food, 'title');

      // Подписка на изменения корзины
      this.basketService.foods
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: Food[]) => {
          let basketFoods = data;
          const existingFood = basketFoods.find(f => f.id === this.food?.id);

          if (existingFood) {
            this.basketFood = existingFood;
          } else {
            this.basketFood = null;
          }
        });
    }
  }

  onCardClicked(): void {
    if (this.stoplist || !this.food) {
      return;
    }

    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');

    this.scrollService.setScrollEnabled(false);
    const dialogRef = this.dialog.open(MenuFoodDialogComponent,
      sheetDialogConfig(this.basketFood ? cloneDeep(this.basketFood) : cloneDeep(this.food)));

    dialogRef.afterClosed().subscribe(() => {
      this.scrollService.setScrollEnabled(true);

      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#f5f5ff');
    });
  }

  ngAfterViewInit(): void {
    if (this.isLast) {
      console.log('FoodCardComponent | onLastItemRendered | List rendering complete');
      this.dataService.setListRendered(true);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
